class ContactsEnrichment {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/contacts-enrichment`;
    this.apiClient = apiClient;

  }

  async enrichContacts(data) {

    return this.apiClient.post(this.basePath, {}, {}, data);

  }

  async getEnrichmentTasks(queryOptions) {

    return this.apiClient.get(this.basePath, {}, queryOptions || {});

  }

}

export default ContactsEnrichment;
